import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontSize: 28,
      textAlign: 'center',
      color: theme.palette.colors.gray1,
      marginBottom: theme.spacing(1),
      fontWeight: 'bold',
    },
    subtitle: {
      fontSize: theme.spacing(2),
      color: theme.palette.colors.gray1,
    },
    containerReproveIcon: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    button: {
      minWidth: 135,
      background: 'linear-gradient(90deg, #249EB2 1.03%, #65C2AF 100%)',
      borderRadius: 5,
      color: theme.palette.colors.gray6,
      fontSize: theme.spacing(2) - 2,
      textTransform: 'none',
      marginBottom: theme.spacing(2),
    },
  }),
);

export default useStyles;
